// extracted by mini-css-extract-plugin
export var divider = "_xa-0";